export default __webpack_public_path__ + "static/media/Arrow_right_fill_new.5a215407.svg";